// Copyright (c) 2023 Ryan Piaskowy. All Rights Reserved.
import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { RotateCw } from "lucide-react";
import "yet-another-react-lightbox/styles.css";

// Native lightbox rendering is required for the Zoom plugin to handle pinch
// gestures correctly on mobile devices.
function EventLightbox({ events, index, onClose }) {
	const [rotation, setRotation] = useState(0);

	useEffect(() => {
		setRotation(0);
	}, [events, index]);

	if (index === null || index === undefined) return null;

	const slides = events.map((event) => ({
		src: event.imageUrl,
		alt: event.eventTitle || "Event flyer",
		title: event.eventTitle,
		description: event.eventVenue,
	}));

	return (
		<Lightbox
			open={index !== null}
			close={onClose}
			index={index}
			slides={slides}
			plugins={[Zoom]}
			carousel={{
				finite: true,
				imageProps: {
					style: {
						transform: `rotate(${rotation}deg)`,
						transition: "transform 180ms ease-out",
					},
				},
			}}
			zoom={{ maxZoomPixelRatio: 4, scrollToZoom: true }}
			render={{
				buttonPrev: () => null,
				buttonNext: () => null,
			}}
			toolbar={{
				buttons: [
					<button
						key="rotate"
						type="button"
						className="yarl__button"
						title="Rotate image clockwise"
						aria-label="Rotate image clockwise"
						onClick={() => setRotation((current) => (current + 90) % 360)}
					>
						<RotateCw aria-hidden="true" size={24} />
					</button>,
					"close",
				],
			}}
		/>
	);
}

export default EventLightbox;
